<template>
  <div class="grille">
    <h1>Grille de Compétences</h1>
    
    <div class="grille-container">
      <div class="grille-actions">
        <a href="/grille/Grille.pdf" target="_blank" class="view-btn">
          <i class="fas fa-external-link-alt"></i>
          Voir en plein écran
        </a>
        <a href="/grille/Grille.pdf" download class="download-btn">
          <i class="fas fa-download"></i>
          Télécharger
        </a>
      </div>

      <div class="grille-preview">
        <iframe 
          src="/grille/Grille.pdf" 
          width="100%" 
          height="1500px"
          title="Aperçu de la grille de compétences"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrillePage'
}
</script>

<style scoped>
.grille {
  color: white;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
  background-color: #01010b;
  position: relative;
}

/* Fond en points */
.grille::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(#2196F3 1px, transparent 1px);
  background-size: 20px 20px;
  opacity: 0.3;
  z-index: -1;
}

h1 {
  text-align: center;
  color: #2196F3;
  margin-bottom: 2rem;
  font-size: 2.5rem;
}

.grille-container {
  background: rgba(0, 0, 0, 0.7);
  border: 1px solid #2196F3;
  border-radius: 10px;
  padding: 1.5rem;
  backdrop-filter: blur(5px);
}

.grille-actions {
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.download-btn, .view-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

.download-btn {
  background: #2196F3;
  color: white;
}

.view-btn {
  background: rgba(33, 150, 243, 0.1);
  color: #64B5F6;
  border: 1px solid #2196F3;
}

.download-btn:hover, .view-btn:hover {
  transform: translateY(-2px);
}

.download-btn:hover {
  background: #64B5F6;
}

.view-btn:hover {
  background: rgba(33, 150, 243, 0.2);
  border-color: #64B5F6;
}

.grille-preview {
  background: white;
  border-radius: 5px;
  overflow: hidden;
}

.grille-preview iframe {
  border: none;
}

@media (max-width: 768px) {
  .grille {
    padding: 1rem;
  }

  h1 {
    font-size: 2rem;
  }

  .grille-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .download-btn, .view-btn {
    justify-content: center;
  }

  .grille-preview iframe {
    height: 800px;
  }
}
</style>
